import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { AuthGuard } from '@/components/eg/auth-guard';
import { EGHeader } from '@/components/eg/eg-header';
import { RouteTracker } from '@/components/eg/route-tracker';

export default function AdminLayout() {
  return (
    <AuthGuard>
      <Suspense>
        <RouteTracker />
      </Suspense>
      <EGHeader isAuthed />
      <main className="mx-auto px-4 pb-8" style={{ maxWidth: 'var(--max-page-container-width-px)' }}>
        <Outlet />
      </main>
    </AuthGuard>
  );
}
